import { PRODUCT_READING } from 'root/lib/constants';

const persistStateTypes = {
  SET_AUTH: 'SET_AUTH',
  UPDATE_TOY: 'UPDATE_TOY',
  SET_AUTH_ERROR: 'SET_AUTH_ERROR',
  GET_GAMESTATE: 'GET_GAMESTATE',
  REQUEST_GAMESTATE: 'REQUEST_GAMESTATE',
  REQUESTRESPONSE_GAMESTATE: 'REQUESTRESPONSE_GAMESTATE',
  REQUESTERROR_GAMESTATE: 'REQUESTERROR_GAMESTATE',
  POST_GAMESTATE: 'POST_GAMESTATE',
  POSTRESPONSE_GAMESTATE: 'POSTRESPONSE_GAMESTATE',
  POSTERROR_GAMESTATE: 'POSTERROR_GAMESTATE',
  REQUEST_GAMESTATE_ALL: 'REQUEST_GAMESTATE_ALL',
  REQUESTRESPONSE_GAMESTATE_ALL: 'REQUESTRESPONSE_GAMESTATE_ALL',
  REQUESTERROR_GAMESTATE_ALL: 'REQUESTERROR_GAMESTATE_ALL',
  LOAD_ADAPTIVITY_MAP: 'LOAD_ADAPTIVITY_MAP',
  REQUEST_RECOMMENDED_SKILLS: 'REQUEST_RECOMMENDED_SKILLS',
  REQUEST_CONTENT_SET: 'REQUEST_CONTENT_SET',
  LOAD_USER_SKILLS: 'LOAD_USER_SKILLS',
  REQUEST_PROFILE: 'REQUEST_PROFILE',
  SET_PROFILE: 'SET_PROFILE',
  LOAD_WORKSHOP_GAMES_FROM_ADAPTIVITY: 'LOAD_WORKSHOP_GAMES_FROM_ADAPTIVITY',
  SAVE_ADAPTIVITY_CONTENT: 'SAVE_ADAPTIVITY_CONTENT',
  SET_VOCAB_RESULTS: 'SET_VOCAB_RESULTS',
  TRANSFORM_PLACEMENT_FIELDS: 'TRANSFORM_PLACEMENT_FIELDS',
};

const initState = {
  firstName: '',
  lastName: '',
  username: '',
  studentId: '',
  sessionId: '',
  grade: '',
  group: '',
  organization: '',
  season: '1',
  seasonLectura: '1',
  seasonPart: 'A',
  seasonPartLectura: 'A',
  skillMap: '',
  skillMapLectura: '',
  toy: '',
  toyLectura: '',

  redirectToIpt: false,
  redirectToIptLectura: false,
  isPlacementAPT: false,
  isPlacementAPTLectura: false,
  isPlacementARBA: false,
  isPlacementARBALectura: false,
  isFirstLogin: false,
  isFirstLoginLectura: false,

  isFieldTrial: false,
  isStaffLogin: false,
  isTestUser: false,
  isSpecialContentLicense: false,
  productsAvailable: [PRODUCT_READING],

  adaptivityContent: [],
};

const persistStateReducer = (state = initState, action) => {
  switch (action.type) {
    case persistStateTypes.TRANSFORM_PLACEMENT_FIELDS:
    case persistStateTypes.UPDATE_TOY:
    case persistStateTypes.SET_AUTH: {
      return { ...state, ...action.payload };
    }
    case persistStateTypes.SAVE_ADAPTIVITY_CONTENT:
      return { ...state, adaptivityContent: [...action.contentSets] };
    default:
      return state;
  }
};

export { persistStateTypes };

export default persistStateReducer;
